import { BankFeedConnectionStatus } from '../../containers/AppPage/Bank/BankFeedConnect/enums/BankFeedConnectionStatus';
import { setErrorReducer, setRequestReducer, setSuccessReducer } from '../helper';
import actions from './actions';
// import { parseExtAccountIds } from './helper';

const initialState = {
    bankFeedReadAllState: false,
    bankFeeds: [],

    bankFeedConnectState: false,
    bankFeedDisconnectState: false,
    bankFeedSyncStates: {}, // key is bankfeedId - eg {1: 'request', 2: 'success', 3: 'error'}

    isOpenAccMappingModal: false,
    accMappingModalBankFeed: {},
    bankFeedMapAccountsState: false,

    isOpenPendingCheckerModal: false,

    bankFeedTransactionReadAllState: false,
    bankFeedTransactions: [],
    bankFeedTransactionsPagination: null,

    bankFeedTransactionDeleteState: false,
    bankFeedTransaction: null,

    bankFeedTransactionBulkDeleteState: false,

    bankFeedSmartReconState: false,
    bankFeedSmartReconStatement: {},
};

const openMappingModalChecker = bankFeed => bankFeed.is_linked === false && [
    BankFeedConnectionStatus.CONNECTED,
    // BankFeedConnectionStatus.PENDING,
].includes(bankFeed.status);

const openPendingModalChecker = bankFeed => bankFeed.is_linked === false && [
    // BankFeedConnectionStatus.CONNECTED,
    BankFeedConnectionStatus.PENDING,
].includes(bankFeed.status);

export default function appReducer(state = initialState, action = {}) {
    switch (action.type) {
        case actions.BANK_FEED_READ_ALL_REQUEST:
            return setRequestReducer(state, 'bankFeedReadAllState');
        case actions.BANK_FEED_READ_ALL_SUCCESS: {
            return setSuccessReducer(state, 'bankFeedReadAllState', {
                ...state,
                // bankFeeds: parsedBankFeeds,
                bankFeeds: action.bank_feeds,

                ...action.hasCreatePermission ? {
                    isOpenAccMappingModal: action.bank_feeds.some(openMappingModalChecker),
                    accMappingModalBankFeed: action.bank_feeds.find(openMappingModalChecker),
                } : {},

                // for non-sole-proprietor, show pending checker modal if PENDING
                isOpenPendingCheckerModal: action.bank_feeds.some(openPendingModalChecker),
            });
        }
        case actions.BANK_FEED_READ_ALL_ERROR:
            return setErrorReducer(state, 'bankFeedReadAllState');

        case actions.BANK_FEED_CONNECT_REQUEST:
            return setRequestReducer(state, 'bankFeedConnectState');
        case actions.BANK_FEED_CONNECT_SUCCESS:
            return setSuccessReducer(state, 'bankFeedConnectState');
        case actions.BANK_FEED_DISCONNECT_REQUEST:
            return setRequestReducer(state, 'bankFeedDisconnectState');
        case actions.BANK_FEED_DISCONNECT_SUCCESS:
            return setSuccessReducer(state, 'bankFeedDisconnectState');
        case actions.BANK_FEED_DISCONNECT_ERROR:
            return setErrorReducer(state, 'bankFeedDisconnectState');

        case actions.BANK_FEED_SYNC_REQUEST: {
            const newBankFeedSyncStates = {...state.bankFeedSyncStates};
            newBankFeedSyncStates[action.bankFeedId] = 'request';
            return {
                ...state,
                bankFeedSyncStates: newBankFeedSyncStates,
            };
        }
        case actions.BANK_FEED_SYNC_SUCCESS: {
            const newBankFeedSyncStates = {...state.bankFeedSyncStates};
            newBankFeedSyncStates[action.bankFeedId] = 'success';
            return {
                ...state,
                bankFeedSyncStates: newBankFeedSyncStates,
            };
        }
        case actions.BANK_FEED_SYNC_ERROR: {
            const newBankFeedSyncStates = {...state.bankFeedSyncStates};
            newBankFeedSyncStates[action.bankFeedId] = 'error';
            return {
                ...state,
                bankFeedSyncStates: newBankFeedSyncStates,
            };
        }

        case actions.SET_ACC_MAPPING_MODAL_OPEN:
            return {
                ...state,
                isOpenAccMappingModal: action.isOpen,
                // accMappingModalBankFeed: action.bankFeed,
            };
        case actions.SET_PENDING_CHECKER_MODAL_OPEN:
            return {
                ...state,
                isOpenPendingCheckerModal: action.isOpen,
            };

        case actions.BANK_FEED_MAP_ACCOUNTS_REQUEST:
            return setRequestReducer(state, 'bankFeedMapAccountsState');
        case actions.BANK_FEED_MAP_ACCOUNTS_SUCCESS:
            return setSuccessReducer(state, 'bankFeedMapAccountsState');
        case actions.BANK_FEED_MAP_ACCOUNTS_ERROR:
            return setErrorReducer(state, 'bankFeedMapAccountsState');

        case actions.BANK_FEED_TRANSACTION_READ_ALL_REQUEST:
            return setRequestReducer(state, 'bankFeedTransactionReadAllState');
        case actions.BANK_FEED_TRANSACTION_READ_ALL_SUCCESS:
            return setSuccessReducer(state, 'bankFeedTransactionReadAllState', {
                ...state,
                bankFeedTransactions: action.bank_feed_transactions,
                bankFeedTransactionsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        case actions.BANK_FEED_TRANSACTION_READ_ALL_ERROR:
            return setErrorReducer(state, 'bankFeedTransactionReadAllState');

        case actions.BANK_FEED_TRANSACTION_DELETE_REQUEST:
            return setRequestReducer(state, 'bankFeedTransactionDeleteState');
        case actions.BANK_FEED_TRANSACTION_DELETE_SUCCESS:
            return setSuccessReducer(state, 'bankFeedTransactionDeleteState');
        case actions.BANK_FEED_TRANSACTION_DELETE_ERROR:
            return setErrorReducer(state, 'bankFeedTransactionDeleteState');

        case actions.BANK_FEED_TRANSACTION_BULK_DELETE_REQUEST:
            return setRequestReducer(state, 'bankFeedTransactionBulkDeleteState');
        case actions.BANK_FEED_TRANSACTION_BULK_DELETE_SUCCESS:
            return setSuccessReducer(state, 'bankFeedTransactionBulkDeleteState');
        case actions.BANK_FEED_TRANSACTION_BULK_DELETE_ERROR:
            return setErrorReducer(state, 'bankFeedTransactionBulkDeleteState');

        case actions.BANK_FEED_SMART_RECON_REQUEST:
            return setRequestReducer(state, 'bankFeedSmartReconState');
        case actions.BANK_FEED_SMART_RECON_SUCCESS:
            return setSuccessReducer(state, 'bankFeedSmartReconState', {
                ...state,
                // bankFeedSmartReconState: 'success',
                bankFeedSmartReconStatement: action.statement,
                // pagination: {
                //     total: action.pagination.total,
                //     current: action.pagination.current_page,
                //     pageSize: action.pagination.per_page,
                // },
            });
        case actions.BANK_FEED_SMART_RECON_ERROR:
            return setErrorReducer(state, 'bankFeedSmartReconState');

        default:
            return state;
    }
}
